import {
  fetchTests as fetchTestsFromAPI,
  saveTest,
  stopTestById,
  fetchBreakoutsByCountryId,
  fetchCarriers as fetchCarriersFromAPI
} from '@/api/routing'

/**
 * Fetch all tests from the API if they haven´t been loaded yet.
 * Access the collection by using the getter 'tests/tests'
 */
const loadTests = async ({ dispatch, state }) => {
  if (state.tests === null || Object.keys(state.tests).length === 0) {
    await dispatch('fetchTests')
  }
}

/**
 * Force a hard refresh of tests and mutate the store
 * Access the collection by using the getter 'tests/tests'
 */
const fetchTests = async ({ commit }) => {
  let response = await fetchTestsFromAPI()
  commit('SET_TESTS', response)
}

/**
 * Stops an unsuccessful test from running.
 * @param {object} payload - { id: '123'}
 */
const stopTest = async ({ commit }, payload) => {
  await stopTestById(payload.id)
  commit('SET_EMPTY_TEST')
}

const startNewTest = async ({ commit, dispatch, state }) => {
  if (state.newTest === null) {
    // start with a clean slate
    commit('SET_EMPTY_TEST')
  }
  await dispatch('fetchBreakouts')
  await dispatch('loadCarriers')
}

const setEmptyTest = ({ commit, dispatch, state }) => {
  commit('SET_EMPTY_TEST')
}

/**
 * Saves the newTest object from the store to the API.
 */
const createTest = async ({ commit, state, dispatch }) => {
  await saveTest(state.newTest).then((value) => {
    commit('SET_EMPTY_TEST')
  })
}

/**
 * Mutate one or more properties on the selected test in the store.
 * @param {object} payload - key value.
 */
const setTest = ({ commit }, payload) => {
  commit('SET_TEST', payload)
}

/**
 * Set countryId on the store and assign it´s value to the newTest object.
 * Triggers a fetch of breakouts for the new country.
 * @param {object} payload - { countryId: 'SE'}
 */
const setCountryId = async ({ commit, dispatch }, payload) => {
  // mutate state country id
  commit('SET_COUNTRY_ID', payload.countryId)
  // update country id on test
  // dispatch('setTest', { countryId: payload.countryId })
  // refresh breakouts on store to be relevant for new country id
  await dispatch('fetchBreakouts')
}

/**
 * Fetch breakouts from API for the countryId set on the store.
 */
const fetchBreakouts = async ({ commit, state }) => {
  let response = await fetchBreakoutsByCountryId(state.countryId)
  commit('SET_BREAKOUTS', response)
}

/**
 * Fetch carriers from the API if they haven´t been loaded yet.
 * Access the collection by using the getter 'tests/carriers'
 */
const loadCarriers = async ({dispatch, state}) => {
  // only fetch carriers from API when empty
  if (state.carriers === null || Object.keys(state.carriers).length === 0) {
    await dispatch('fetchCarriers')
  }
}

/**
 * Hard refresh of carriers
 */
const fetchCarriers = async ({commit, state}) => {
  let response = await fetchCarriersFromAPI()
  commit('SET_CARRIERS', response)
}

export default {
  loadTests,
  fetchTests,
  stopTest,
  startNewTest,
  setEmptyTest,
  createTest,
  setTest,
  fetchBreakouts,
  setCountryId,
  loadCarriers,
  fetchCarriers
}



// WEBPACK FOOTER //
// ./src/store/modules/tests/actions.js